export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/views/NewPassword.vue'),
  },
  {
    path: '/odin',
    name: 'Odin',
    meta: { authRequired: true },
    redirect: '/loki',
    // component: () => import('@/views/odin/main.vue'),
    // children: [
    //   {
    //     path: '/',
    //     name: 'home',
    //     component: () => import('@/views/odin/Dashboard.vue'),
    //   },
    //   {
    //     path: 'incidents',
    //     name: 'incidents',
    //     component: () => import('@/views/odin/incidents/index.vue'),
    //   },
    //   {
    //     path: 'incidents/:id',
    //     name: 'detail-incident',
    //     component: () => import('@/views/odin/incidents/details.vue'),
    //   },
    //   {
    //     path: 'requests',
    //     name: 'requests',
    //     component: () => import('@/views/odin/requests/index.vue'),
    //   },
    //   {
    //     path: 'requests/:id',
    //     name: 'edit-request',
    //     component: () => import('@/views/odin/requests/details.vue'),
    //   },
    //   {
    //     path: 'new-request',
    //     name: 'rew-request',
    //     component: () => import('@/views/odin/requests/new.vue'),
    //   },
    //   {
    //     path: 'customers',
    //     name: 'customers',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customers/index.vue'),
    //   },
    //   {
    //     path: 'new-customer',
    //     name: 'new-customer',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customers/new.vue'),
    //   },
    //   {
    //     path: 'customer-management',
    //     name: 'customersManagement',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customers/index.vue'),
    //   },
    //   {
    //     path: 'customers/:id',
    //     name: 'edit-customers',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customers/new.vue'),
    //   },
    //   {
    //     path: 'mss-users',
    //     name: 'mss-users',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/mss-users/index.vue'),
    //   },
    //   {
    //     path: 'mss-users/:id',
    //     name: 'edit-mss-user',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/mss-users/new.vue'),
    //   },
    //   {
    //     path: 'new-mss-user',
    //     name: 'new-mss-user',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/mss-users/new.vue'),
    //   },
    //   {
    //     path: 'customer-users',
    //     name: 'customer-users',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customer-users/index.vue'),
    //   },
    //   {
    //     path: 'customer-new-user',
    //     name: 'customer-new-user',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customer-users/new.vue'),
    //   },
    //   {
    //     path: 'customer-edit-user/:id',
    //     name: 'customer-edit-user',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/customer-users/new.vue'),
    //   },
    //   {
    //     path: 'siem-correlation-rules',
    //     name: 'siem-correlation-rules',
    //     meta: { isAdmin: true },
    //     component: () =>
    //       import('@/views/odin/siem-correlation-rules/index.vue'),
    //   },
    //   {
    //     path: 'new-siem-correlation-rule',
    //     name: 'new-siem-correlation-rule',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/siem-correlation-rules/new.vue'),
    //   },
    //   {
    //     path: 'edit-siem-correlation-rule/:id',
    //     name: 'edit-siem-correlation-rule',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/siem-correlation-rules/new.vue'),
    //   },
    //   {
    //     path: 'siem-management',
    //     name: 'siem-management',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/siem-management/index.vue'),
    //   },
    //   {
    //     path: 'new-siem-management',
    //     name: 'new-siem-management',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/siem-management/new.vue'),
    //   },
    //   {
    //     path: 'edit-siem-management/:id',
    //     name: 'edit-siem-management',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/siem-management/new.vue'),
    //   },
    //   {
    //     path: 'playbook',
    //     name: 'Playbook',
    //     component: () => import('@/views/odin/playbook/index.vue'),
    //   },
    //   {
    //     path: 'print/playbook/:id',
    //     name: 'PlaybookPrint',
    //     component: () => import('@/views/odin/playbook/print.vue'),
    //   },
    //   {
    //     path: 'playbook/:id',
    //     name: 'PlaybookDetails',
    //     component: () => import('@/views/odin/playbook/form.vue'),
    //   },
    //   {
    //     path: 'rules-documentation',
    //     name: 'RulesDocumentation',
    //     component: () => import('@/views/odin/rule-documentation/index.vue'),
    //   },
    //   {
    //     path: 'print/rules-documentation/:id',
    //     name: 'RulesDocumentationPrint',
    //     component: () => import('@/views/odin/rule-documentation/print.vue'),
    //   },
    //   {
    //     path: 'rules-documentation/:id',
    //     name: 'RulesDocumentationDetails',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/rule-documentation/details.vue'),
    //   },
    //   {
    //     path: 'mitre',
    //     name: 'MitreAttack',
    //     component: () => import('@/views/odin/mitre-attack/index.vue'),
    //   },
    //   {
    //     path: 'mitre/new',
    //     name: 'MitreAttack-new',
    //     meta: { isAdmin: true },
    //     component: () => import('@/views/odin/mitre-attack/new.vue'),
    //   },
    // ],
  },

  {
    path: '/user-profile',
    name: 'user-profile',
    component: () => import('@/views/UserProfile.vue'),
    meta: { authRequired: true },
  },
  {
    path: '/gv',
    name: 'Vulnerability',
    component: () => import('@/views/vulnerability/Main'),
    meta: { authRequired: true },
    children: [
      {
        path: '/',
        name: 'HomeDashboard',
        component: () => import('@/views/vulnerability/Dashboard'),
      },
      {
        path: 'list',
        name: 'VulnerabilityList',
        component: () => import('@/views/vulnerability/List'),
      },
      {
        path: 'assets-list',
        name: 'AssetsLists',
        component: () => import('@/views/vulnerability/AssetsList'),
      },
      {
        path: 'files-management',
        name: 'FilesManagement',
        component: () => import('@/views/vulnerability/FilesManage'),
      },
      {
        path: 'action-plan-details/:id',
        name: 'ActionPlanDetails',
        component: () => import('@/views/vulnerability/action-plan/Details'),
      },
      {
        path: 'action-plan-list',
        name: 'ActionPlanList',
        component: () => import('@/views/vulnerability/action-plan/List'),
      },
    ],
  },
  {
    path: '/loki',
    name: 'LokiDashboard',
    meta: { authRequired: true },
    component: () => import('@/views/loki/Main'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/loki/Dashboard'),
      },
      {
        path: 'details/:origin',
        name: 'Details',
        component: () => import('@/views/loki/DetailsGeneric'),
      },
      {
        path: 'management-channels',
        name: 'Channels',
        component: () => import('@/views/loki/ManagementChannels'),
      },
      {
        path: 'management-leaks',
        name: 'Leaks',
        component: () => import('@/views/loki/ManagementLeaks'),
      },
      {
        path: 'management-integrations',
        name: 'Integrations',
        component: () => import('@/views/loki/Integrations'),
      },
    ],
  },
  {
    path: '/',
    redirect: '/loki',
  },
  {
    path: '/swagger',
    beforeEnter: (to, from, next) => {
      if (process.env.NODE_ENV !== 'development') next('/loki')
      else next()
    },
    meta: { authRequired: true },
    component: () => import('@/views/odin/main.vue'),
    children: [
      {
        path: '/',
        component: () => import('@/views/swagger')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    name: 'bad-not-found',
    component: () => import('@/views/NotFound'),
  },
]
